export function kjoregarLogger() {
  console.log(
    ` 
    %c           G                  
              !@.                 
              &@?    7            
             ?@@&   P@            
             &@@@~ Y@@:           
            7@@@@G7@@@?           
            &@@@@@@@@@&           
            &@@@@@@@@@@~   ^:     
       :#   B@@@@@@@@@@B   #B     
       G@Y  5@@@@@@@@@@@. J@@^    
       &@@Y J@@@@@@@@@@@7.@@@B    
       @@@@7Y@@@@@@@@@@@&&@@@@.   
       &@@@@@@@@@@@YB@@@@@@@@@:   
       #@@@@@@@@@@~  B@@@@@@@@^   
       P@@@@@@@@@:    B@@@@@@@~   
       J@@@@@@@#.      #@@@@@@: .
       ^@@@@@@Y  :~!~. .#@@@@@:#Y 
    ~P !@@@@@^ Y@@@@@@&^.B@@@@&@! 
    ~@@&@@@#. #@@@@@@&@&. 5@@@@@! 
     &@@@@G  7@@@@@@5::JJ  5@@@@5 
     Y@@@5   5@@@@G:^^^?Y  .5@@@& 
     7@@7    B@@@?^~^^^7P .. G@@@.
     Y@!     &@5:^^::::~G .  :#@@7
     #~      Y^~^^^^^^^!G   ..:B@B
    J! ......:::^^^^~^^~!^^~~~!?##
    .........Kjøregår.............
    `,
    'background: #272D2A; color:  #FFFCB6'
  );
}
